<div class="mt-4">
  <div class="table-responsive">
    <table
      class="table t-elevated-shadow-cap"
      aria-describedby="partes por sesión">
      <thead>
        <tr>
          <th scope="col">Id Localizador</th>
          <th scope="col">Sesión</th>
          <th scope="col">Compartido por</th>
          <th scope="col">Fecha inicio</th>
          <th scope="col" class="text-center">#Partes</th>
          <th scope="col" class="text-center">QR Maestro</th>
          <th scope="col" class="text-center">Ver QR</th>
          <th scope="col" class="text-center">Asistencia</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let sessionItem of sessions">
          <th scope="row">{{ sessionItem.IdLocalizador }}</th>
          <td>
            {{ sessionItem.titulo }}
          </td>
          <td>{{ sessionItem.nombrePropietario }}</td>
          <td>
            {{
              sessionItem.fechaInicio
                | date: "dd/MM/yyyy" : "" : "es-mx"
                | titlecase
            }}
          </td>
          <td class="text-center">{{ sessionItem.totalPartesReales }}</td>
          <td class="text-center">{{ sessionItem.QrMeastro ? "Sí" : "No" }}</td>
          <th scope="row" class="text-center">
            <button
              mat-mini-fab
              class="mat-mini-custom"
              color="primary"
              ngbTooltip="Generar QR"
              (click)="openModal(sessionItem)">
              <mat-icon>qr_code_2_add</mat-icon>
            </button>
          </th>
          <th scope="row" class="text-center">
            <button
              mat-mini-fab
              class="mat-mini-custom"
              color="primary"
              ngbTooltip="Ver asistencia"
              [routerLink]="['/myQrs', 'view-attendece', sessionItem.Id]"
              routerLinkActive="router-link-active">
              <mat-icon>checklist</mat-icon>
            </button>
          </th>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<app-general-empty-modal #modal [modalConfig]="modalConfig">
  <ng-container *ngIf="selectedSesion">
    <app-modal-course-card
      [data]="selectedSesion"
      (closeModalEmitter)="closeModal()"></app-modal-course-card>
  </ng-container>
</app-general-empty-modal>
